import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import CustomAddressComercioExteriorSuggestions from '../../../../catalogs/CustomAddressComercioExteriorSuggestions';

class ComercioExteriorDomicilioForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  getSortedCatalogo = (values, label, id) => {
    if (!values) {
      return [];
    }

    return _.sortBy(
      values.map((item) => {
        return {
          label: item[label],
          value: item[id],
        };
      }),
      'label'
    );
  };

  rules(data) {
    const { required } = this.props;
    const isDomicilioTouched = this.isDomicilioTouched(data);

    const Calle = ['string', 'min:4', 'max:100'];
    const NumeroExterior = ['string', 'min:1', 'max:55'];
    const NumeroInterior = ['string', 'min:1', 'max:55'];
    const Colonia = ['string', 'min:1', 'max:120'];
    const Localidad = ['string', 'min:1', 'max:120'];
    const Referencia = ['string', 'min:1', 'max:250'];
    const Municipio = ['string', 'min:1', 'max:120'];
    const Estado = ['string', 'min:1', 'max:30'];
    const Pais = ['string', 'min:3', 'max:3'];
    const CodigoPostal = ['string', 'min:1', 'max:12'];

    const isRequired = required || isDomicilioTouched;

    return {
      Calle: isRequired ? ['required'].concat(Calle) : Calle,
      NumeroExterior: isRequired ? NumeroExterior : NumeroExterior,
      NumeroInterior: isRequired ? NumeroInterior : NumeroInterior,
      Colonia: isRequired ? Colonia : Colonia,
      Localidad: isRequired ? Localidad : Localidad,
      Referencia: isRequired ? Referencia : Referencia,
      Municipio: isRequired ? Municipio : Municipio,
      Estado: isRequired ? ['required'].concat(Estado) : Estado,
      Pais: isRequired ? ['required'].concat(Pais) : Pais,
      CodigoPostal: isRequired ? ['required'].concat(CodigoPostal) : CodigoPostal,
    };
  }

  isDomicilioTouched = (values) => {
    const props = [
      'Calle',
      'NumeroExterior',
      'NumeroInterior',
      'Colonia',
      'Localidad',
      'Referencia',
      'Municipio',
      'Estado',
      'Pais',
      'CodigoPostal',
    ];

    let touched = false;

    for (const prop of props) {
      if (values[prop] !== undefined && values[prop] !== '') {
        touched = true;
        break;
      }
    }

    return touched;
  };

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);

    this.setState({
      isValid: validator.passes(),
    });

    this.props.onFormDataChange({
      data,
      isValid: validator.passes(),
      isTouched: true,
    });
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnSuggestionSelect = (name) => (item) => {
    if (!item) {
      return;
    }

    const value = item ? item.clave : '';

    let values = {
      [name]: value,
    };

    if (!!item) {
      const { id } = item;

      if (id !== '7683b916-556a-4ac6-9e1f-e9089e8a066a') {
        values = {
          [name]: value,
          Municipio: item.clave_municipio,
          Pais: item.clave_pais,
          Estado: item.clave_estado,
          Colonia: item.clave_colonia || undefined,
          Localidad: item.clave_localidad || undefined,
        };
      }
    }

    // Si código postal vacío reset de valores
    if (!item) {
      values = {
        [name]: value,
        Municipio: '',
        Pais: '',
        Estado: '',
        Colonia: '',
        Localidad: '',
      };
    }

    this.handleOnChange(values);
  };

  handleOnRef = (ref) => {
    this._refCalle = ref.ref;
  };

  render() {
    const { data } = this.props;
    const rules = this.rules(data);

    return (
      <>
        <Row className="pb-3">
          <Col>
            <CustomAddressComercioExteriorSuggestions
              name="CodigoPostal"
              id="CodigoPostal"
              label="Código Postal"
              help=""
              rules={rules.CodigoPostal}
              value={data.CodigoPostal}
              onSelect={this.handleOnSuggestionSelect('CodigoPostal')}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Calle"
              name="Calle"
              placeholder=""
              help=""
              minLength="1"
              maxLength="100"
              rules={rules.Calle}
              value={data.Calle}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Número Exterior"
              name="NumeroExterior"
              placeholder=""
              help=""
              minLength="1"
              maxLength="55"
              rules={rules.NumeroExterior}
              value={data.NumeroExterior}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Número Interior"
              name="NumeroInterior"
              placeholder=""
              help=""
              minLength="1"
              maxLength="55"
              rules={rules.NumeroInterior}
              value={data.NumeroInterior}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Colonia"
              name="Colonia"
              placeholder=""
              help=""
              minLength="1"
              maxLength="120"
              rules={rules.Colonia}
              value={data.Colonia}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Localidad"
              name="Localidad"
              placeholder=""
              help=""
              minLength="1"
              maxLength="120"
              rules={rules.Localidad}
              value={data.Localidad}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Referencia"
              name="Referencia"
              placeholder=""
              help=""
              minLength="1"
              maxLength="250"
              rules={rules.Referencia}
              value={data.Referencia}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Municipio"
              name="Municipio"
              placeholder=""
              help=""
              minLength="1"
              maxLength="120"
              rules={rules.Municipio}
              value={data.Municipio}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Estado"
              name="Estado"
              placeholder=""
              casing={'upper'}
              help=""
              minLength="1"
              maxLength="30"
              rules={rules.Estado}
              value={data.Estado}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="País"
              name="Pais"
              placeholder=""
              casing={'upper'}
              help=""
              minLength="3"
              maxLength="3"
              rules={rules.Pais}
              value={data.Pais}
              //options={ }
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default ComercioExteriorDomicilioForm;
